/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs */

const en_forms_teams_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask = /** @type {(inputs: Forms_Teams_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login Mask`)
};

const de_forms_teams_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask = /** @type {(inputs: Forms_Teams_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer kann Pausengrund ändern`)
};

/**
* | output |
* | --- |
* | "Login Mask" |
*
* @param {Forms_Teams_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask = /** @type {((inputs?: Forms_Teams_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask(inputs)
	return de_forms_teams_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask(inputs)
});